import React, { useState } from 'react';
import { X } from 'lucide-react';
import images from '../data/images.json';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeFilter, setActiveFilter] = useState('all');

  const allImages = [
    ...images.gallery.truck,
    ...images.gallery.events,
    ...images.gallery.food,
    ...images.gallery.branding
  ];

  const filters = [
    { id: 'all', label: 'Tutto' },
    { id: 'truck', label: 'Il Truck' },
    { id: 'events', label: 'Eventi' },
    { id: 'food', label: 'Food' },
    { id: 'branding', label: 'Brand Activation' }
  ];

  const filteredImages = activeFilter === 'all' 
    ? allImages 
    : allImages.filter(img => img.category === activeFilter);

  return (
    <section id="gallery" className="py-24 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-amber-50 mb-6">
            Gallery
          </h2>
          <p className="text-xl text-amber-100/70 max-w-3xl mx-auto">
            Scopri l'icona americana in azione: eventi, dettagli e atmosfera
          </p>
          <div className="w-24 h-1 bg-red-600 mx-auto mt-6"></div>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {filters.map((filter) => (
            <button
              key={filter.id}
              onClick={() => setActiveFilter(filter.id)}
              className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                activeFilter === filter.id
                  ? 'bg-red-600 text-white shadow-lg shadow-red-600/50'
                  : 'bg-amber-50/10 text-amber-100/70 hover:bg-amber-50/20 border border-amber-200/10'
              }`}
            >
              {filter.label}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((image, index) => {
            // Determine strategic caption based on category
            let strategicCaption = image.alt;
            if (image.category === 'truck') strategicCaption = 'Premium vintage asset';
            if (image.category === 'branding') strategicCaption = 'Brand activation example';
            if (image.category === 'events') strategicCaption = 'Experiential marketing';
            if (image.category === 'food') strategicCaption = 'Corporate hospitality';

            return (
              <div
                key={index}
                onClick={() => setSelectedImage(image)}
                className="group relative aspect-square overflow-hidden rounded-xl cursor-pointer"
              >
                <img
                  src={image.url}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-neutral-900/90 via-neutral-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <p className="text-amber-400 text-sm font-medium mb-1 tracking-wide uppercase">
                      {strategicCaption}
                    </p>
                    <p className="text-amber-50/80 text-sm font-light">{image.alt}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white hover:text-amber-200 transition-colors"
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={selectedImage.url}
            alt={selectedImage.alt}
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default Gallery;
